








































































import Vue from 'vue';
import axios from 'axios';
import ConfirmDelete from '../components/ConfirmDelete.vue';
import CreateFillerBetaPdf from '../components/CreateFillerBetaPdf.vue';
import { buildPagination } from '../utils/pagination';

export default Vue.extend({
    name: 'FillerBeta',
    components: { ConfirmDelete, CreateFillerBetaPdf },
    data() {
        return {
            templates: [] as any[],
            currentPageNum: 1 as number,
            numItems: 10,
            pagination: [] as (number | '...')[],
            showAdd: false,
            addMode: 'choose' as 'choose' | 'upload' | 'design',
            newName: '',
            newFile: null as File | null,
            uploading: false,
            checkingDesignName: false,
            showConfirmDelete: false,
            fillerToDelete: '',
            showCreatePDF: false,
            fillerToCreate: ''
        }
    },
    created() {
        // On a hard refresh App.vue's own session/tier fetch is still in
        // flight when this fires - checking tier immediately would race it
        // and always see the default (non-premium) tier. Wait for that
        // fetch to finish before gating on it.
        if(this.$store.state.sessionChecked) {
            this.checkTierAndLoad();
        } else {
            const unwatch = this.$watch(() => this.$store.state.sessionChecked, (checked: boolean) => {
                if(checked) {
                    unwatch();
                    this.checkTierAndLoad();
                }
            });
        }
    },
    methods: {
        checkTierAndLoad() {
            if(this.$store.state.tier != 2) {
                alert('The Form Filler is a Premium feature. Upgrade your plan to Premium to gain access.');
                this.$router.push('/payment');
                return;
            }
            this.getTemplates()
                .then(() => {
                    this.$store.state.routeLoaded = true;
                });
        },
        async getTemplates() {
            const url = `${this.$store.state.apiUrl}/filler/templates?pageNum=${this.currentPageNum}&numItems=${this.numItems}`;
            await axios.get(url)
                .then(resp => {
                    this.templates = resp.data.templates;
                    const totalPages = Math.ceil(resp.data.totalRows / this.numItems);
                    this.pagination = buildPagination(this.currentPageNum, totalPages);
                })
                .catch(e => {
                    console.log(e.response?.data);
                });
        },
        changePage(num: number) {
            this.currentPageNum = num;
            this.getTemplates();
        },
        onFileChange() {
            const files = (this.$refs.file as any).files;
            this.newFile = files && files[0] ? files[0] : null;
        },
        openAdd() {
            this.addMode = 'choose';
            this.showAdd = true;
        },
        closeAdd() {
            this.showAdd = false;
            this.newName = '';
            this.newFile = null;
        },
        async continueToDesigner() {
            if(this.checkingDesignName) return;
            const name = this.newName.replace(/ /g, '_');
            if(!name) {
                alert('Must include a name.');
                return;
            }

            this.checkingDesignName = true;
            let exists = false;
            await axios.get(this.$store.state.apiUrl + '/filler/templates/' + encodeURIComponent(name))
                .then(resp => {
                    if(resp.data.template) exists = true;
                })
                .catch(e => { console.log(e); });
            this.checkingDesignName = false;
            if(exists) {
                alert('There is already a template with this name.');
                return;
            }

            this.closeAdd();
            this.$router.push('/filler-beta/design/' + encodeURIComponent(name));
        },
        async uploadNew() {
            if(this.uploading) return;
            const name = this.newName.replace(/ /g, '_');
            if(!name) {
                alert('Must include a name.');
                return;
            }
            if(!this.newFile) {
                alert('No PDF selected.');
                return;
            }

            let exists = false;
            await axios.get(this.$store.state.apiUrl + '/filler/templates/' + encodeURIComponent(name))
                .then(resp => {
                    if(resp.data.template) exists = true;
                })
                .catch(e => { console.log(e); });
            if(exists) {
                alert('There is already a template with this name.');
                return;
            }

            this.uploading = true;
            const formData = new FormData();
            formData.set('name', name);
            formData.set('contactProps', JSON.stringify([]));
            formData.set('companyProps', JSON.stringify([]));
            formData.set('isNew', 'true');
            formData.append('file', this.newFile);
            axios.post(this.$store.state.apiUrl + '/filler/template', formData)
                .then(() => {
                    this.uploading = false;
                    this.closeAdd();
                    this.$router.push('/filler-beta/' + encodeURIComponent(name));
                })
                .catch(e => {
                    alert(e.response ? e.response.data : 'There was an error.');
                    this.uploading = false;
                });
        },
        editTemplate(name: string) {
            this.$router.push('/filler-beta/' + encodeURIComponent(name));
        },
        createPDF(name: string) {
            this.fillerToCreate = name;
            this.showCreatePDF = true;
        },
        closeCreatePDF() {
            this.showCreatePDF = false;
        },
        confirmDelete(name: string) {
            this.showConfirmDelete = true;
            this.fillerToDelete = name;
        },
        confirmDeleteTemplate() {
            this.showConfirmDelete = false;
            axios.delete(this.$store.state.apiUrl + '/filler/template/' + encodeURIComponent(this.fillerToDelete))
                .then(() => {
                    alert('Template deleted.');
                    this.currentPageNum = 1;
                    this.getTemplates();
                })
                .catch(e => {
                    alert('There was an error.')
                })
        },
        cancelDeleteTemplate() {
            this.showConfirmDelete = false;
        }
    }
})
